import defaultStates, { defaultLifeCycle } from '@/constants/lifecycle';

const roleActions = {
  APPLY_DEFAULT_ROLE_CODE: 'APPLY_DEFAULT_ROLE_CODE',
  CLOSE_ROLE: 'CLOSE_ROLE',
  CLOSE_ROLES: 'CLOSE_ROLES',
  CREATE_ROLE: 'CREATE_ROLE',
  EDIT_ROLE: 'EDIT_ROLE',
  EDIT_ROLE_CANCEL: 'EDIT_ROLE_CANCEL',
  EDIT_ROLE_ERROR: 'EDIT_ROLE_ERROR',
  EDIT_ROLE_SUCCESS: 'EDIT_ROLE_SUCCESS',
  FETCH_DEFAULT_ROLE: 'FETCH_DEFAULT_ROLE',
  FETCH_ROLE: 'FETCH_ROLE',
  FETCH_ROLES: 'FETCH_ROLES',
  HIDE_CONFIRM_PERMISSIONS: 'HIDE_CONFIRM_PERMISSIONS',
  HIDE_DEFAULT_ROLE: 'HIDE_DEFAULT_ROLE',
  HIDE_SAVE_ROLE: 'HIDE_SAVE_ROLE',
  HIDE_USERS_ROLE_REASSIGN: 'HIDE_USERS_ROLE_REASSIGN',
  NEW_ROLE: 'NEW_ROLE',
  NEW_ROLE_ERROR: 'NEW_ROLE_ERROR',
  REFRESH_ROLES: 'REFRESH_ROLES',
  SHOW_CONFIRM_PERMISSIONS: 'SHOW_CONFIRM_PERMISSIONS',
  SHOW_DEFAULT_ROLE: 'SHOW_DEFAULT_ROLE',
  SHOW_ROLE_REASSIGN: 'SHOW_ROLE_REASSIGN',
  SHOW_ROLE: 'SHOW_ROLE',
  SHOW_ROLE_ERROR: 'SHOW_ROLE_ERROR',
  SHOW_ROLES: 'SHOW_ROLES',
  SHOW_ROLES_ERROR: 'SHOW_ROLES_ERROR',
  SHOW_SAVE_ROLE: 'SHOW_SAVE_ROLE',
  TOGGLE_ROLE_PERMISSION: 'TOGGLE_ROLE_PERMISSION',
  TOGGLE_ROLE_SELECTED: 'TOGGLE_ROLE_SELECTED',
  TOGGLE_ROLES_PRESENTATION: 'TOGGLE_ROLES_PRESENTATION',
  TOGGLE_ROLES_SELECTED: 'TOGGLE_ROLES_SELECTED',
  UPDATE_ACTIVE_ROLE_PROPERTIES: 'UPDATE_ACTIVE_ROLE_PROPERTIES',
  UPDATE_PERMISSIONS_PANELS: 'UPDATE_PERMISSIONS_PANELS',
  UPDATE_ROLE: 'UPDATE_ROLE',
  UPDATE_ROLE_FILTER: 'UPDATE_ROLE_FILTER',
  UPDATE_ROLE_PERMISSIONS: 'UPDATE_ROLE_PERMISSIONS',
  UPDATE_ROLE_PROPERTIES: 'UPDATE_ROLE_PROPERTIES',
  UPDATE_ROLES_FILTER: 'UPDATE_ROLES_FILTER',
  UPDATE_ROLES_FLAGS: 'UPDATE_ROLES_FLAGS',
  UPDATE_USERS_ROLE: 'UPDATE_USERS_ROLE',
  UPDATE_USERS_ROLE_ERROR: 'UPDATE_USERS_ROLE_ERROR',
  UPDATE_USERS_ROLE_SUCCESS: 'UPDATE_USERS_ROLE_SUCCESS',
};

export const roleLists = ['all', 'lookups'];

export const roleCategories = [...roleLists, 'open'];

export const roleLifeCycle = [...defaultLifeCycle];

export const roleStates = {
  ...defaultStates,
};

export const roleGroupings = {
  USERS: 'users',
  TOKENS: 'tokens',
};

const CRUD_NONE = {
  create: false,
  read: false,
  update: false,
  destroy: false,
};

const DATASET_NONE = {
  ...CRUD_NONE,
  profile: false,
  preview: false,
  download: false,
  upload: false,
  audit: false,
  secure: false,
  share: false,
  summary: false,
};

const SEARCH_NONE = {
  ...CRUD_NONE,
  share: false,
  secure: false,
  audit: false,
  run: false,
  vector: false,
};

const COHORTS_NONE = {
  ...CRUD_NONE,
  share: false,
  secure: false,
  audit: false,
};

const ATTACHMENTS_NONE = {
  ...CRUD_NONE,
  download: false,
};

const DATA_MODELS_NONE = {
  ...CRUD_NONE,
  audit: false,
};

const ROLES_NONE = {
  ...CRUD_NONE,
  audit: false,
  assign: false,
};

const USERS_NONE = {
  approve: false,
  audit: false,
  destroy: false,
  read: false,
  token_create: false,
  token_destroy: false,
  token_disable: false,
  token_read: false,
  update: false,
};

const USER_GROUPS_NONE = {
  ...CRUD_NONE,
  audit: false,
  assign: false,
};

const TOKENS_NONE = {
  read: false,
  disable: false,
  destroy: false,
};

const REQUESTS_NONE = {
  ...CRUD_NONE,
  review: false,
  audit: false,
  request_workspace: false,
};

const WORKFLOWS_NONE = {
  read: false,
  update: false,
};

const CATALOGUE_DEFINITIONS_NONE = {
  ...CRUD_NONE,
};

const TRANSFERS_NONE = {
  read: false,
  create: false,
};

const COLLECTIONS_NONE = {
  create: false,
  update: false,
  destroy: false,
  audit: false,
  datasets: false,
};

const TASK_DEFINITIONS_NONE = {
  ...CRUD_NONE,
};

const TASK_QUERIES_NONE = {
  ...CRUD_NONE,
  share: false,
  secure: false,
  audit: false,
};

const TASKS_NONE = {
  manage: false,
  read: false,
  unclaim: false,
  update: false,
};

export const permissionActions = {
  APPROVE: { name: 'approve', icon: 'thumbs up' },
  ASSIGN: { name: 'assign', icon: 'hand point right outline' },
  AUDIT: { name: 'audit', icon: 'history' },
  COLLECTIONS_DATASETS: { name: 'datasets', icon: 'table' },
  CREATE: { name: 'create', icon: 'plus' },
  DESTROY: { name: 'destroy', icon: 'trash' },
  DISABLE: { name: 'disable', icon: 'wait' },
  DOWNLOAD: { name: 'download', icon: 'download' },
  INGEST: { name: 'ingest', icon: 'arrow alternate circle right' },
  MANAGE: { name: 'manage', icon: 'cogs' },
  READ: { name: 'read', icon: 'eye' },
  REVIEW: { name: 'review', icon: 'thumbs up' },
  RUN: { name: 'run', icon: 'search' },
  SECURE: { name: 'secure', icon: 'lock' },
  SHARE: { name: 'share', icon: 'share' },
  SYSTEM_NOTIFY: { name: 'notify', icon: 'send' },
  SYSTEM_REVIEW: { name: 'system_review', icon: 'thumbs up' },
  SYSTEM_TOKEN_CREATE: { name: 'system_token_create', icon: 'plus' },
  UNCLAIM: { name: 'unclaim', icon: 'remove user' },
  UPDATE: { name: 'update', icon: 'pencil' },
  UPLOAD: { name: 'upload', icon: 'upload' },
  USERS_TOKEN_CREATE: { name: 'token_create', icon: 'plus' },
  USERS_TOKEN_DISABLE: { name: 'token_disable', icon: 'wait' },
  USERS_TOKEN_DESTROY: { name: 'token_destroy', icon: 'trash' },
  USERS_TOKEN_READ: { name: 'token_read', icon: 'eye' },
};

export const experimentalSearchPermissionActions = {
  CUSTOM_WEIGHTS: { name: 'custom_weights', icon: 'balance scale' },
  VECTOR: { name: 'vector', icon: 'wizard' },
};

const CREATE_AND_READ = [
  permissionActions.CREATE,
  permissionActions.READ,
];

const SHARE_AND_SECURE = [
  permissionActions.SHARE,
  permissionActions.SECURE,
];

const CRUD_ACTIONS = [
  ...CREATE_AND_READ,
  permissionActions.UPDATE,
  permissionActions.DESTROY,
];

export const permissionCategories = {
  ATTACHMENTS: {
    name: 'attachments',
    icon: 'attach',
    actions: [...CRUD_ACTIONS, permissionActions.DOWNLOAD, permissionActions.INGEST],
  },
  AUDIT: {
    name: 'audit',
    icon: 'history',
    actions: [permissionActions.READ],
  },
  CATALOGUE_DEFINITIONS: {
    name: 'cataloguedefinitions',
    icon: 'book',
    actions: [...CRUD_ACTIONS],
  },
  COHORTS: {
    name: 'cohorts',
    icon: 'sitemap',
    actions: [...CRUD_ACTIONS, ...SHARE_AND_SECURE, permissionActions.AUDIT],
  },
  COLLECTIONS: {
    name: 'collections',
    icon: 'object group outline',
    actions: [
      permissionActions.CREATE,
      permissionActions.UPDATE,
      permissionActions.DESTROY,
      permissionActions.AUDIT,
      ...SHARE_AND_SECURE,
      permissionActions.COLLECTIONS_DATASETS,
    ],
  },
  CONFIGURATIONS: {
    name: 'configurations',
    icon: 'settings',
    actions: [permissionActions.READ, permissionActions.UPDATE],
  },
  DATA_MODELS: {
    name: 'datamodels',
    icon: 'tag',
    actions: [...CRUD_ACTIONS, permissionActions.AUDIT],
  },
  DATASETS: {
    name: 'datasets',
    icon: 'table',
    actions: [
      ...CRUD_ACTIONS,
      permissionActions.UPLOAD,
      permissionActions.DOWNLOAD,
      ...SHARE_AND_SECURE,
      permissionActions.AUDIT,
    ],
  },
  DATASOURCE_TYPES: {
    name: 'datasourcetypes',
    icon: 'server',
    actions: [
      permissionActions.READ,
      permissionActions.UPDATE,
    ],
  },
  REQUESTS: {
    name: 'requests',
    icon: 'key',
    actions: [
      ...CREATE_AND_READ,
      permissionActions.DESTROY,
      permissionActions.REVIEW,
      permissionActions.AUDIT,
    ],
  },
  ROLES: {
    name: 'roles',
    icon: 'drivers license',
    actions: [...CRUD_ACTIONS, permissionActions.ASSIGN, permissionActions.AUDIT],
  },
  SEARCH: {
    name: 'search',
    icon: 'search',
    actions: [
      permissionActions.RUN,
      ...CRUD_ACTIONS,
      ...SHARE_AND_SECURE,
      permissionActions.AUDIT,
      experimentalSearchPermissionActions.VECTOR,
      experimentalSearchPermissionActions.CUSTOM_WEIGHTS,
    ],
  },
  SEARCH_CONFIG: {
    name: 'search-config',
    icon: 'search plus',
    actions: [...CRUD_ACTIONS],
  },
  TASK_DEFINITIONS: {
    name: 'taskdefinitions',
    icon: 'wpforms',
    actions: [...CRUD_ACTIONS],
  },
  TASK_QUERIES: {
    name: 'taskqueries',
    icon: 'filter',
    actions: [...CRUD_ACTIONS, ...SHARE_AND_SECURE, permissionActions.AUDIT],
  },
  TASKS: {
    name: 'tasks',
    icon: 'tasks',
    actions: [permissionActions.MANAGE, permissionActions.READ, permissionActions.UPDATE, permissionActions.UNCLAIM],
  },
  THEMES: {
    name: 'themes',
    icon: 'paint brush',
    actions: [permissionActions.UPDATE],
  },
  TOKENS: {
    name: 'tokens',
    icon: 'code',
    actions: [permissionActions.READ, permissionActions.DISABLE, permissionActions.DESTROY],
  },
  TRANSFERS: {
    name: 'transfers',
    icon: 'exchange',
    actions: [permissionActions.READ, permissionActions.CREATE],
  },
  USER_GROUPS: {
    name: 'usergroups',
    icon: 'users',
    actions: [...CRUD_ACTIONS,
      permissionActions.AUDIT,
      permissionActions.ASSIGN,
    ],
  },
  USERS: {
    name: 'users',
    icon: 'user',
    actions: [
      permissionActions.APPROVE,
      permissionActions.AUDIT,
      permissionActions.DESTROY,
      permissionActions.READ,
      permissionActions.UPDATE,
    ],
  },
  USERS_TOKEN: {
    name: 'users',
    icon: 'code',
    actions: [permissionActions.USERS_TOKEN_CREATE,
      permissionActions.USERS_TOKEN_READ,
      permissionActions.USERS_TOKEN_DISABLE,
      permissionActions.USERS_TOKEN_DESTROY],
  },
  VOCABULARIES: {
    name: 'vocabularies',
    icon: 'font',
    actions: [permissionActions.UPDATE],
  },
  WORKFLOWS: {
    name: 'workflows',
    icon: 'fork',
    actions: [permissionActions.READ, permissionActions.UPDATE],
  },
};

export const tokenPermissionCategories = {
  ATTACHMENTS: {
    name: 'attachments',
    icon: 'attach',
    actions: [...CREATE_AND_READ, permissionActions.DESTROY],
  },
  AUDIT: { ...permissionCategories.AUDIT },
  COHORTS: { ...permissionCategories.COHORTS },
  COLLECTIONS: { ...permissionCategories.COLLECTIONS },
  CONFIGURATIONS: { ...permissionCategories.CONFIGURATIONS },
  DATA_MODELS: { ...permissionCategories.DATA_MODELS },
  DATAFILES: {
    name: 'datafiles',
    icon: 'attach',
    actions: [permissionActions.CREATE, permissionActions.DESTROY, permissionActions.INGEST],
  },
  DATASETS: {
    name: 'datasets',
    icon: 'table',
    actions: [
      ...CRUD_ACTIONS,
      permissionActions.UPLOAD,
      ...SHARE_AND_SECURE,
      permissionActions.AUDIT,
    ],
  },
  DATASOURCE_TYPES: { ...permissionCategories.DATASOURCE_TYPES },
  REQUESTS: {
    name: 'requests',
    icon: 'key',
    actions: [
      ...CREATE_AND_READ,
      permissionActions.DESTROY,
      permissionActions.REVIEW,
      permissionActions.AUDIT,
      permissionActions.SYSTEM_NOTIFY,
      permissionActions.SYSTEM_TOKEN_CREATE,
      permissionActions.SYSTEM_REVIEW,
    ],
  },
  SEARCH: { ...permissionCategories.SEARCH },
  SEARCH_CONFIG: { ...permissionCategories.SEARCH_CONFIG },
  TASKS: {
    name: 'tasks',
    icon: 'tasks',
    actions: [permissionActions.READ, permissionActions.UPDATE],
  },
  TASK_QUERIES: { ...permissionCategories.TASK_QUERIES },
  TRANSFERS: { ...permissionCategories.TRANSFERS },
  WORKFLOWS: { ...permissionCategories.WORKFLOWS },
};

export const requestPermissions = [
  permissionCategories.REQUESTS,
  permissionCategories.TRANSFERS,
  permissionCategories.WORKFLOWS,
  permissionCategories.TASKS,
  permissionCategories.TASK_QUERIES,
  permissionCategories.TASK_DEFINITIONS,
];

export const datasetPermissions = [
  permissionCategories.DATASETS,
  permissionCategories.ATTACHMENTS,
  permissionCategories.CATALOGUE_DEFINITIONS,
];

export const adminPermissions = [
  permissionCategories.THEMES,
  permissionCategories.VOCABULARIES,
  permissionCategories.ROLES,
  permissionCategories.AUDIT,
  permissionCategories.USERS,
  permissionCategories.CONFIGURATIONS,
  permissionCategories.TOKENS,
  permissionCategories.SEARCH_CONFIG,
  permissionCategories.DATASOURCE_TYPES,
  permissionCategories.DATA_MODELS,
];

export const collectionPermissions = [
  permissionCategories.COLLECTIONS,
];

export const allPermissionCategories = [
  ...datasetPermissions,
  ...requestPermissions,
  ...adminPermissions,
  ...collectionPermissions,
  permissionCategories.SEARCH,
  permissionCategories.COHORTS,
  permissionCategories.USERS_TOKEN,
  permissionCategories.USER_GROUPS,
];

export const tokenPermissions = [
  tokenPermissionCategories.DATASETS,
  tokenPermissionCategories.ATTACHMENTS,
  tokenPermissionCategories.REQUESTS,
  tokenPermissionCategories.SEARCH,
  tokenPermissionCategories.COHORTS,
];

export const requestTokenPermissions = [
  tokenPermissionCategories.REQUESTS,
  tokenPermissionCategories.WORKFLOWS,
  tokenPermissionCategories.TRANSFERS,
  tokenPermissionCategories.TASKS,
  tokenPermissionCategories.TASK_QUERIES,
];

export const datasetTokenPermissions = [
  tokenPermissionCategories.DATASETS,
  tokenPermissionCategories.ATTACHMENTS,
];

export const adminTokenPermissions = [
  tokenPermissionCategories.AUDIT,
  permissionCategories.CATALOGUE_DEFINITIONS,
  tokenPermissionCategories.COLLECTIONS,
  tokenPermissionCategories.SEARCH_CONFIG,
  permissionCategories.CONFIGURATIONS,
  permissionCategories.DATASOURCE_TYPES,
  permissionCategories.DATA_MODELS,
];

export const allTokenPermissionCategories = [
  ...datasetTokenPermissions,
  ...requestTokenPermissions,
  ...adminTokenPermissions,
  permissionCategories.SEARCH,
  permissionCategories.COHORTS,
];

const on = (category, action) => (
  { category: category.name, action: action.name, value: true }
);

const off = (category, action) => (
  { category: category.name, action: action.name, value: false }
);

const crudDependencies = (category, shareable = false, auditable = false) => {
  const readOff = [off(category, permissionActions.UPDATE), off(category, permissionActions.DESTROY)];
  if (shareable) {
    readOff.push(off(category, permissionActions.SHARE));
    readOff.push(off(category, permissionActions.SECURE));
  }
  if (auditable) {
    readOff.push(off(category, permissionActions.AUDIT));
  }

  return ({
    read: { off: readOff },
    update: { on: [on(category, permissionActions.READ)] },
    destroy: { on: [on(category, permissionActions.READ)] },
  });
};

const shareDependencies = (category) => ({
  share: { on: [on(category, permissionActions.READ)], off: [off(category, permissionActions.SECURE)] },
  secure: { on: [on(category, permissionActions.READ), on(category, permissionActions.SHARE)] },
});

const searchDependencies = {
  run: {
    off: [
      ...crudDependencies(permissionCategories.SEARCH, true, true).read.off,
      off(permissionCategories.SEARCH, permissionActions.READ),
    ],
  },
  read: {
    on: [on(permissionCategories.SEARCH, permissionActions.RUN)],
    off: crudDependencies(permissionCategories.SEARCH, true, true).read.off,
  },
  update: {
    on: [
      on(permissionCategories.SEARCH, permissionActions.RUN),
      ...crudDependencies(permissionCategories.SEARCH).update.on,
    ],
  },
  destroy: {
    on: [
      on(permissionCategories.SEARCH, permissionActions.RUN),
      ...crudDependencies(permissionCategories.SEARCH).destroy.on,
    ],
  },
  audit: {
    on: [
      on(permissionCategories.SEARCH, permissionActions.RUN),
      on(permissionCategories.SEARCH, permissionActions.READ),
    ],
  },
  share: {
    on: [
      on(permissionCategories.SEARCH, permissionActions.RUN),
      ...shareDependencies(permissionCategories.SEARCH).share.on,
    ],
    off: shareDependencies(permissionCategories.SEARCH).share.off,
  },
  secure: {
    on: [
      on(permissionCategories.SEARCH, permissionActions.RUN),
      ...shareDependencies(permissionCategories.SEARCH).secure.on,
    ],
    off: shareDependencies(permissionCategories.SEARCH).secure.off,
  },
};

const cohortDependencies = {
  read: { off: crudDependencies(permissionCategories.COHORTS, true, true).read.off },
  update: { on: crudDependencies(permissionCategories.COHORTS).update.on },
  destroy: { on: crudDependencies(permissionCategories.COHORTS).destroy.on },
  audit: { on: [on(permissionCategories.COHORTS, permissionActions.READ)] },
  ...shareDependencies(permissionCategories.COHORTS),
};

const catalogueTemplateDependencies = {
  read: {
    off: crudDependencies(permissionCategories.CATALOGUE_DEFINITIONS).read.off,
  },
  update: { on: crudDependencies(permissionCategories.CATALOGUE_DEFINITIONS).update.on },
  destroy: { on: crudDependencies(permissionCategories.CATALOGUE_DEFINITIONS).destroy.on },
};

const roleDependencies = {
  read: {
    off: [
      ...crudDependencies(permissionCategories.ROLES, false, true).read.off,
      off(permissionCategories.ROLES, permissionActions.ASSIGN),
    ],
  },
  update: { on: crudDependencies(permissionCategories.ROLES).update.on },
  destroy: { on: crudDependencies(permissionCategories.ROLES).destroy.on },
  assign: { on: [on(permissionCategories.ROLES, permissionActions.READ)] },
  audit: { on: [on(permissionCategories.ROLES, permissionActions.READ)] },
};

const dataModelDependencies = {
  read: {
    off: crudDependencies(permissionCategories.DATA_MODELS, false, true).read.off,
  },
  update: { on: crudDependencies(permissionCategories.DATA_MODELS).update.on },
  destroy: { on: crudDependencies(permissionCategories.DATA_MODELS).destroy.on },
  audit: { on: [on(permissionCategories.DATA_MODELS, permissionActions.READ)] },
};

const attachmentsDependencies = {
  read: {
    off: [
      ...crudDependencies(permissionCategories.ATTACHMENTS).read.off,
      off(permissionCategories.ATTACHMENTS, permissionActions.DOWNLOAD),
      off(permissionCategories.ATTACHMENTS, permissionActions.CREATE),
    ],
  },
  update: { on: crudDependencies(permissionCategories.ATTACHMENTS).update.on },
  destroy: {
    on:
      [
        ...crudDependencies(permissionCategories.ATTACHMENTS).destroy.on,
        on(permissionCategories.ATTACHMENTS, permissionActions.READ),
        on(permissionCategories.DATASETS, permissionActions.READ),
      ],
  },
  download: {
    on: [
      on(permissionCategories.DATASETS, permissionActions.READ),
      on(permissionCategories.ATTACHMENTS, permissionActions.READ),
    ],
  },
  create: {
    on: [
      on(permissionCategories.DATASETS, permissionActions.READ),
      on(permissionCategories.ATTACHMENTS, permissionActions.READ),
    ],
  },
};

const datasetDependencies = {
  create: { off: [off(permissionCategories.WORKFLOWS, permissionActions.READ)] },
  read: {
    off: [
      ...crudDependencies(permissionCategories.DATASETS, true, true).read.off,
      off(permissionCategories.CATALOGUE_DEFINITIONS, permissionActions.READ),
      off(permissionCategories.DATASETS, permissionActions.DOWNLOAD),
      off(permissionCategories.ATTACHMENTS, permissionActions.READ),
      off(permissionCategories.REQUESTS, permissionActions.CREATE),
      off(permissionCategories.REQUESTS, permissionActions.AUDIT),
      ...attachmentsDependencies.read.off,
    ],
    on: [
      on(permissionCategories.CATALOGUE_DEFINITIONS, permissionActions.READ),
    ],
  },
  update: { on: crudDependencies(permissionCategories.DATASETS).update.on },
  destroy: { on: crudDependencies(permissionCategories.DATASETS).destroy.on },
  download: { on: [on(permissionCategories.DATASETS, permissionActions.READ)] },
  audit: { on: [on(permissionCategories.DATASETS, permissionActions.READ)] },
  ...shareDependencies(permissionCategories.DATASETS),
};

const requestDependencies = {
  create: {
    on: [
      on(permissionCategories.DATASETS, permissionActions.READ),
      on(permissionCategories.REQUESTS, permissionActions.READ),
      on(permissionCategories.TRANSFERS, permissionActions.READ),
      on(permissionCategories.TRANSFERS, permissionActions.CREATE),
    ],
  },
  read: {
    off: [
      ...crudDependencies(permissionCategories.REQUESTS, false, true).read.off,
      off(permissionCategories.REQUESTS, permissionActions.REVIEW),
      off(permissionCategories.TRANSFERS, permissionActions.READ),
      off(permissionCategories.TRANSFERS, permissionActions.CREATE),
    ],
  },
  update: { on: crudDependencies(permissionCategories.REQUESTS).update.on },
  destroy: { on: crudDependencies(permissionCategories.REQUESTS).destroy.on },
  review: { on: [on(permissionCategories.REQUESTS, permissionActions.READ)] },
  audit: { on: [on(permissionCategories.REQUESTS, permissionActions.READ)] },
};

const workflowDependencies = {
  read: {
    off: [off(permissionCategories.WORKFLOWS, permissionActions.UPDATE)],
    on: [on(permissionCategories.DATASETS, permissionActions.CREATE)],
  },
  update: { on: [on(permissionCategories.WORKFLOWS, permissionActions.READ)] },
};

const userDependencies = {
  ...crudDependencies(permissionCategories.USERS, false, true),
  approve: {
    on: [on(permissionCategories.USERS, permissionActions.READ)],
  },
  token_read: {
    off: [
      off(permissionCategories.USERS_TOKEN, permissionActions.USERS_TOKEN_CREATE),
      off(permissionCategories.USERS_TOKEN, permissionActions.USERS_TOKEN_DESTROY),
      off(permissionCategories.USERS_TOKEN, permissionActions.USERS_TOKEN_DISABLE),
    ],
  },
  token_create: { on: [on(permissionCategories.USERS_TOKEN, permissionActions.USERS_TOKEN_READ)] },
  token_destroy: { on: [on(permissionCategories.USERS_TOKEN, permissionActions.USERS_TOKEN_READ)] },
  token_disable: { on: [on(permissionCategories.USERS_TOKEN, permissionActions.USERS_TOKEN_READ)] },
};

const userGroupDependencies = {
  ...crudDependencies(permissionCategories.USER_GROUPS, false, true),
  audit: { on: [on(permissionCategories.USER_GROUPS, permissionActions.READ)] },
};

const tokenDependencies = {
  read: {
    off: [
      ...crudDependencies(permissionCategories.TOKENS).read.off,
      off(permissionCategories.TOKENS, permissionActions.DISABLE),
    ],
  },
  destroy: { on: crudDependencies(permissionCategories.TOKENS).destroy.on },
  disable: { on: [on(permissionCategories.TOKENS, permissionActions.READ)] },
};

const configurationDependencies = {
  read: {
    off: [off(permissionCategories.CONFIGURATIONS, permissionActions.UPDATE)],
  },
  update: { on: [on(permissionCategories.CONFIGURATIONS, permissionActions.READ)] },
};

const taskQueryDependencies = {
  read: { off: crudDependencies(permissionCategories.TASK_QUERIES, true, true).read.off },
  update: { on: crudDependencies(permissionCategories.TASK_QUERIES).update.on },
  destroy: { on: crudDependencies(permissionCategories.TASK_QUERIES).destroy.on },
  audit: { on: [on(permissionCategories.TASK_QUERIES, permissionActions.READ)] },
  ...shareDependencies(permissionCategories.TASK_QUERIES),
};

const taskTemplateDependencies = {
  read: {
    off: crudDependencies(permissionCategories.TASK_DEFINITIONS).read.off,
  },
  update: { on: crudDependencies(permissionCategories.TASK_DEFINITIONS).update.on },
  destroy: { on: crudDependencies(permissionCategories.TASK_DEFINITIONS).destroy.on },
};

const taskDependencies = {
  manage: { on: [off(permissionCategories.TASKS, permissionActions.READ)] },
  read: { off: [off(permissionCategories.TASKS, permissionActions.UPDATE)] },
  update: { on: [on(permissionCategories.TASKS, permissionActions.READ)] },
  unclaim: {
    on: [
      on(permissionCategories.TASKS, permissionActions.READ),
      on(permissionCategories.TASKS, permissionActions.UPDATE),
    ],
  },
};

export const permissionDependencies = {
  attachments: attachmentsDependencies,
  cohorts: cohortDependencies,
  configurations: configurationDependencies,
  cataloguedefinitions: catalogueTemplateDependencies,
  datamodels: dataModelDependencies,
  datasets: datasetDependencies,
  requests: requestDependencies,
  roles: roleDependencies,
  search: searchDependencies,
  tasks: taskDependencies,
  taskqueries: taskQueryDependencies,
  taskdefinitions: taskTemplateDependencies,
  tokens: tokenDependencies,
  users: userDependencies,
  usergroups: userGroupDependencies,
  workflows: workflowDependencies,
};

export const defaultPermissions = {
  activities: CRUD_NONE,
  attachments: ATTACHMENTS_NONE,
  audit: CRUD_NONE,
  cataloguedefinitions: CATALOGUE_DEFINITIONS_NONE,
  cohorts: COHORTS_NONE,
  collections: COLLECTIONS_NONE,
  configurations: CRUD_NONE,
  datamodels: DATA_MODELS_NONE,
  datasets: DATASET_NONE,
  requests: REQUESTS_NONE,
  roles: ROLES_NONE,
  search: SEARCH_NONE,
  taskdefinitions: TASK_DEFINITIONS_NONE,
  taskqueries: TASK_QUERIES_NONE,
  tasks: TASKS_NONE,
  themes: CRUD_NONE,
  tokens: TOKENS_NONE,
  transfers: TRANSFERS_NONE,
  users: USERS_NONE,
  usergroups: USER_GROUPS_NONE,
  vocabularies: CRUD_NONE,
  workflows: WORKFLOWS_NONE,
};

// super permissions is full access
export const superPermissions = () => {
  const permissions = {};

  Object.entries(defaultPermissions).forEach(([category]) => {
    permissions[category] = permissions[category] ? permissions[category] : {};
    Object.entries(defaultPermissions[category]).forEach(([action]) => {
      permissions[category][action] = true;
    });
  });

  return permissions;
};

export default roleActions;
